import { render, staticRenderFns } from "./nav-bar-store.vue?vue&type=template&id=20563ac6&scoped=true"
import script from "./nav-bar-store.vue?vue&type=script&lang=js"
export * from "./nav-bar-store.vue?vue&type=script&lang=js"
import style0 from "./nav-bar-store.vue?vue&type=style&index=0&id=20563ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20563ac6",
  null
  
)

export default component.exports